module.exports = __webpack_public_path__ + "img/barre-4.c7be0673.png";